var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 40 40"}},[_c('defs',[_c('path',{attrs:{"id":"a","d":"M9.28 18.013L26.92.333l2.36 2.36-20 20L0 13.413l2.32-2.36z"}})]),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(5 8)","fill":"currentColor","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }